import { Toast, Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import { Variant } from '../common/types'
import { HEADER_HEIGHT } from './Navigation/constants'
import { RucksackNotification } from './RucksackNotification'
import { INotification, useNotifications } from '../state/modules/notifications'

function getSeverity(
  notification: INotification
): 'error' | 'info' | 'success' {
  if (notification.variant === Variant.DANGER) return 'error'
  if (notification.persistent) return 'info'
  return 'success'
}

function NotificationsToast() {
  const { data, dismiss } = useNotifications()

  function displayRucksackNotifications() {
    const rucksackNotifications = data.filter((n) => n.useRucksackUI === true)
    return rucksackNotifications.map((notification) => (
      <RucksackNotification
        title={notification.title}
        message={notification.message}
        key={notification.id}
        severity={getSeverity(notification)}
        onClose={
          notification.persistent ? undefined : () => dismiss(notification.id)
        }
      />
    ))
  }

  function displayLegacyNotifications() {
    const legacyNotifications = data.filter((n) => !n.useRucksackUI)
    return legacyNotifications.map((notification) => (
      <Toast
        className={`bg-${notification.variant}`}
        onClick={() => dismiss(notification.id)}
        key={notification.id}
      >
        <Toast.Header style={{ justifyContent: 'space-between' }}>
          <strong className="me-auto">{notification.title}</strong>
        </Toast.Header>
        <Toast.Body>{notification.message}</Toast.Body>
      </Toast>
    ))
  }

  return (
    <>
      <Row
        style={{
          position: 'fixed',
          width: '100vw',
          bottom: '1rem',
          left: '1rem',
          color: 'white',
          zIndex: '1100',
        }}
      >
        <Col md={6} className="mb-2">
          {displayLegacyNotifications()}
        </Col>
      </Row>
      {/* Not a Bootstrap grid Row/Col - just a fixed-position stack, so a
          plain flex column is used instead of Row (which defaults to a
          horizontal flex layout and would lay multiple toasts out
          side-by-side rather than stacking them). */}
      <div
        style={{
          position: 'fixed',
          top: `${HEADER_HEIGHT + 16}px`,
          right: '2rem',
          color: 'white',
          zIndex: 1100,
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}
      >
        {displayRucksackNotifications()}
      </div>
    </>
  )
}

export default styled(NotificationsToast)`
  & {
  }
`
